var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.config.global.homeSliderFull)?[_c('Slider',{attrs:{"maxHeight":"100vh"}})]:_vm._e(),(!_vm.config.global.homeSliderFull)?[_c('Slider')]:_vm._e(),_c('div',{staticClass:"wrap"},[_c('Level4Search'),_c('Locations')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }